import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import urls from '../../utils/urls';
import { getIntl } from '../../utils/intl';
import { appAPI } from '../../utils/api';
import { getOneUpEndpointsSearchCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useOneUpEndpointsSearch', {
    errorSearching: 'Error searching for patient portals',
});

export type UseOneUpEndpointsSearchArgs = {
    search: string;
};

export type UseOneUpEndpointsSearchReturnValue = {
    isLoading: boolean;
    endpoints: APITypes.ehrIntegrationsService.OneUpHealthEndpoint[];
};

export default function useOneUpHealthEndpointsSearch({
    search,
}: UseOneUpEndpointsSearchArgs): UseOneUpEndpointsSearchReturnValue {
    const endpointSearchQuery = useQuery({
        queryKey: getOneUpEndpointsSearchCacheKey(search),

        queryFn: async () => {
            return await appAPI.post(urls.api.ehrIntegrations.oneUpHealth.endpoints.search, {
                body: { search } as APITypes.ehrIntegrationsService.OneUpHealthEndpointsSearchRequest,
            });
        },
        enabled: !!search,
    });
    useQueryErrorNotify(endpointSearchQuery, intl('errorSearching'));

    return {
        isLoading: endpointSearchQuery.isLoading,
        endpoints: endpointSearchQuery.data?.endpoints || [],
    };
}
